import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { FEATURED, PRICE } from "../data/collections";
import { colorOf } from "../data/site";
import Reveal from "./Reveal";

export default function FeaturedRail() {
  const railRef = useRef(null);
  const scroll = (dir) => {
    const el = railRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  return (
    <section className="relative py-24 md:py-32 bg-[#FAFAF7]" data-testid="featured-rail">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="flex items-end justify-between gap-6 mb-10 md:mb-12">
          <Reveal>
            <div>
              <p className="eyebrow mb-4">Best sellers</p>
              <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.025em]">
                The <span className="italic">crowd</span> favourites.
              </h2>
            </div>
          </Reveal>
          <div className="hidden md:flex items-center gap-2">
            <button onClick={() => scroll(-1)} aria-label="Scroll left" className="w-12 h-12 rounded-full border border-[#2C2C2A]/15 inline-flex items-center justify-center hover:bg-[#2C2C2A] hover:text-[#FAFAF7] transition-colors" data-testid="rail-prev">
              <ArrowLeft className="w-4 h-4" />
            </button>
            <button onClick={() => scroll(1)} aria-label="Scroll right" className="w-12 h-12 rounded-full border border-[#2C2C2A]/15 inline-flex items-center justify-center hover:bg-[#2C2C2A] hover:text-[#FAFAF7] transition-colors" data-testid="rail-next">
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      <Reveal>
      <div ref={railRef} className="scroll-hide overflow-x-auto px-5 md:px-10">
        <div className="flex gap-5 md:gap-7 mx-auto max-w-[1440px]" style={{ width: "max-content" }}>
          {FEATURED.map((c, i) => (
              <Link
                key={c.slug}
                to={`/collection/${c.slug}`}
                className="group flex-shrink-0 w-[78vw] sm:w-[420px] lg:w-[460px] rounded-[28px] overflow-hidden bg-[#F3EADA] block lift"
                data-testid={`featured-${c.slug}`}
                data-hover="true"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={`/products/${c.slug}-kid.jpg`}
                    alt={c.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-[1200ms]"
                  />
                  <div className="absolute top-4 left-4 text-[11px] font-medium uppercase tracking-[0.2em] bg-[#FAFAF7] rounded-full px-3 py-1.5">
                    {c.audience.replace("For ", "")}
                  </div>
                </div>
                <div className="px-6 py-5 flex items-center justify-between">
                  <div className="min-w-0">
                    <h3 className="font-serif text-3xl leading-none">{c.name}</h3>
                    <p className="mt-2 text-[13px] text-[#595955] line-clamp-1">{c.tagline[0]}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="text-sm font-medium">{PRICE}</span>
                    <span className="text-[10px] uppercase tracking-[0.15em] text-[#595955]">Shipping charges extra</span>
                  </div>
                </div>
              </Link>
          ))}
          <div className="flex-shrink-0 w-10" />
        </div>
      </div>
      </Reveal>
    </section>
  );
}
